export const CALL_DISCONNECTED_EVENT = 'ergeon:call-disconnected';

export interface CallDisconnectedDetail {
  callSid: string;
}

export const dispatchCallDisconnected = (callSid: string) => {
  window.dispatchEvent(
    new CustomEvent<CallDisconnectedDetail>(CALL_DISCONNECTED_EVENT, {
      detail: { callSid },
    }),
  );
};
